if (!window.__dataClickAnchorBound) {
  window.__dataClickAnchorBound = true;
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-click]');
    if (!trigger) return;
    const id = trigger.getAttribute('data-click');
    if (!id) return;
    e.preventDefault();

    const target = document.getElementById(id);
    if (target) {
      if (target.matches('a, button, [role="button"]')) target.click();
      else target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const anchor = document.createElement('a');
    anchor.href = '#' + id;
    anchor.hidden = true;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  let coupon = new Swiper(".reward-coupon-section .swiper-container", {
    grid: {
      fill: "row",
      rows: 2,
    },
    slidesPerView: 2,
    spaceBetween: 10,
    observer: true,
    resizeObserver: true,
    pagination: {
      el: ".reward-coupon-section .reward-pagination",
      clickable: true,
    },
    breakpoints: {
      1000: {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: ".reward-coupon-section .reward-arrow-next",
          prevEl: ".reward-coupon-section .reward-arrow-prev",
        },
        grid:false
      },
    },
  });

  let couponRulesOpener = null;

  function closeCouponRules() {
    $('.reward-coupon-section .rules-notice-bg').removeClass('active');
    $('.reward-coupon-section .rules-notice-bg .rules-notice-box').removeClass('active');
    if (couponRulesOpener) couponRulesOpener.focus();
  }

  // reward coupon section点击每个item的rules出现弹窗
  $('.reward-coupon-section .rules-link').click(function () {
    let link_index = $(this).data('index');
    couponRulesOpener = this;
    $('.reward-coupon-section .rules-notice-bg').addClass('active');
    $('.reward-coupon-section .rules-notice-bg .rules-notice-box').removeClass('active');
    $(`.reward-coupon-section .rules-notice-bg .rules-notice-box[data-index=${link_index}]`).addClass('active');
    $('.reward-coupon-section .rules-close-btn').trigger('focus');
  });

  $('.reward-coupon-section .rules-close-btn').click(function (e) {
    e.stopPropagation();
    closeCouponRules();
  });

  $('.reward-coupon-section .rules-notice-bg').click(function (e) {
    if (e.target === this) closeCouponRules();
  });

  $(document).on('keydown.rewardCouponRules', function (e) {
    const bg = document.querySelector('.reward-coupon-section .rules-notice-bg');
    if (!bg || !bg.classList.contains('active')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeCouponRules();
    }
  });
});
